var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading",class:{'no-line': !_vm.hasToggle, 'is-expanded': _vm.expanded, 'is-collapsed': !_vm.expanded},on:{"click":_vm.toggle}},[(_vm.hasToggle)?_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa",class:_vm.expanded ? 'fa-minus-square-o' : 'fa-plus-square-o'})]):_vm._e(),_vm._v(" "),(_vm.isMobile && _vm.$slots.mobile)?_vm._t("mobile"):_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52179662","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panel/MobileToggle.vue
// module id = 1155
// module chunks = 0